import React from "react";

const bhajanClubbingMetadata = {
  title: "Americans4Hindus (A4H) Presents Bhajan Clubbing",
  description: "Live music · Bhajans · Sing Along · $25 with Dinner Included.",
  image: "https://www.americans4hindus.org/bhajanclubbing-og.png",
  url: "https://www.americans4hindus.org/bhajanclubbing/",
};

function BhajanClubbing() {
  React.useEffect(() => {
    const previousTitle = document.title;
    const managedTags = [
      ["meta[property='og:title']", "property", "og:title", bhajanClubbingMetadata.title],
      ["meta[property='og:description']", "property", "og:description", bhajanClubbingMetadata.description],
      ["meta[property='og:image']", "property", "og:image", bhajanClubbingMetadata.image],
      ["meta[property='og:url']", "property", "og:url", bhajanClubbingMetadata.url],
      ["meta[name='twitter:card']", "name", "twitter:card", "summary_large_image"],
      ["meta[name='twitter:title']", "name", "twitter:title", bhajanClubbingMetadata.title],
      ["meta[name='twitter:description']", "name", "twitter:description", bhajanClubbingMetadata.description],
      ["meta[name='twitter:image']", "name", "twitter:image", bhajanClubbingMetadata.image],
    ];

    document.title = bhajanClubbingMetadata.title;
    managedTags.forEach(([selector, attribute, key, content]) => {
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attribute, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    return () => {
      document.title = previousTitle;
      managedTags.forEach(([selector]) => {
        document.head.querySelector(selector)?.remove();
      });
    };
  }, []);

  return (
    <iframe
      src="https://americans4hindus-mi.github.io/bhajanclubbing/"
      title="Bhajan Clubbing"
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
      }}
    />
  );
}

export default BhajanClubbing;
